import React from "react";
import Link from "next/link";
import { Button } from "../button";
import { Disclosure, Transition } from "@headlessui/react";
import { shouldRel } from "./utils";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var MobileMenu = _ref => {
  var {
    mainItems
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: "flex md:hidden items-start flex-col gap-4 px-4",
    children: mainItems.map((_ref2, i) => {
      var {
        label,
        href,
        sections = []
      } = _ref2;
      return /*#__PURE__*/_jsxs(Disclosure, {
        children: [/*#__PURE__*/_jsx(Disclosure.Button, {
          as: React.Fragment,
          children: /*#__PURE__*/_jsx(Button, {
            className: "dropdown-button",
            color: "transparent",
            children: label
          })
        }), sections.length ? /*#__PURE__*/_jsx(Transition, {
          as: React.Fragment,
          enter: "transition ease-out duration-200",
          enterFrom: "opacity-0 translate-y-1",
          enterTo: "opacity-100 translate-y-0",
          leave: "transition ease-in duration-150",
          leaveFrom: "opacity-100 translate-y-0",
          leaveTo: "opacity-0 translate-y-1",
          children: /*#__PURE__*/_jsxs(Disclosure.Panel, {
            className: "grid gap-2 w-full",
            children: [/*#__PURE__*/_jsx(Link, {
              href: href,
              children: /*#__PURE__*/_jsx("a", {
                rel: shouldRel(href),
                className: "text-xl font-black px-4 py-1 md:px-6 md:py-2",
                children: label
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "grid gap-2 mt-2",
              children: sections.map((_ref3, i) => {
                var {
                  label,
                  items = []
                } = _ref3;
                return /*#__PURE__*/_jsxs("div", {
                  children: [/*#__PURE__*/_jsx(Link, {
                    href: href,
                    children: /*#__PURE__*/_jsx("a", {
                      rel: shouldRel(href),
                      className: "text-lg font-bold px-4 py-1 md:px-6 md:py-2",
                      children: label
                    })
                  }), /*#__PURE__*/_jsxs("div", {
                    children: [items.map((_ref4, i) => {
                      var {
                        label,
                        href
                      } = _ref4;
                      return /*#__PURE__*/_jsx("div", {
                        children: /*#__PURE__*/_jsx(Link, {
                          href: href,
                          children: /*#__PURE__*/_jsx("a", {
                            className: "text-sm px-4 py-1 md:px-6 md:py-2",
                            rel: shouldRel(href),
                            children: label
                          })
                        })
                      }, i);
                    }), items[0] && /*#__PURE__*/_jsx("div", {
                      className: "w-full",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: href,
                        children: /*#__PURE__*/_jsx("a", {
                          className: "text-sm px-4 py-1 md:px-6 md:py-2",
                          rel: shouldRel(href),
                          children: "View more..."
                        })
                      })
                    })]
                  })]
                }, i);
              })
            })]
          })
        }) : null]
      }, i);
    })
  });
};
//# sourceMappingURL=mobile_menu.js.map